import React from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CompactSelect from "./CompactSelect";

/**
 * Unified listing filters: dates, status, extra actions, search, Excel, clear.
 */
const ListingFilters = ({
  startDate,
  endDate,
  onStartDate,
  onEndDate,
  showDates = true,

  search,
  onSearch,
  searchPlaceholder = "Search",
  showSearch = true,

  status,
  onStatus,
  statusOptions,
  statusLabel = "Status",

  actions,

  onApply,
  applyLabel = "Load Records",
  showApply = false,

  onExport,
  exportLabel = "EXPORT TO EXCEL",
  exporting = false,
  showExport,

  onClear,
  showClear = true,
  clearLabel = "Clear",

  className = "",
}) => {
  const canClear = showClear && typeof onClear === "function";
  const canApply = showApply && typeof onApply === "function";
  const canExport =
    (showExport === undefined ? typeof onExport === "function" : showExport) &&
    typeof onExport === "function";

  return (
    <div
      className={`ds-listing-filters ${
        canApply ? "has-apply" : "no-apply"
      } ${className}`.trim()}
    >
      <div className="ds-listing-filters__left">
        {showDates && (
          <div className="ds-listing-dates">
            <label className="ds-listing-field">
              <span className="ds-listing-field__label">From</span>
              <input
                type="date"
                value={startDate || ""}
                onChange={(e) => onStartDate?.(e.target.value)}
                className="ds-input ds-filter-date"
              />
            </label>
            <label className="ds-listing-field">
              <span className="ds-listing-field__label">To</span>
              <input
                type="date"
                value={endDate || ""}
                onChange={(e) => onEndDate?.(e.target.value)}
                className="ds-input ds-filter-date"
              />
            </label>
          </div>
        )}

        {Array.isArray(statusOptions) && statusOptions.length > 0 && (
          <label className="ds-listing-field ds-filter-active">
            <span className="ds-listing-field__label">{statusLabel}</span>
            <CompactSelect
              className="ds-filter-status-select"
              value={status || ""}
              onChange={(v) => onStatus?.(v)}
              options={statusOptions}
              placeholder="All"
              ariaLabel={statusLabel}
            />
          </label>
        )}
      </div>

      {actions ? <div className="ds-listing-actions">{actions}</div> : null}

      {(showSearch || canApply || canClear || canExport) && (
        <div className="ds-listing-filters__right">
          {showSearch && (
            <input
              type="search"
              value={search || ""}
              onChange={(e) => onSearch?.(e.target.value)}
              placeholder={searchPlaceholder}
              className="ds-input ds-filter-search"
            />
          )}

          {canApply && (
            <button
              type="button"
              className="ds-btn ds-btn-primary ds-filter-apply"
              onClick={onApply}
            >
              {applyLabel}
            </button>
          )}

          {canExport && (
            <button
              type="button"
              className="ds-action-btn ds-filter-export"
              disabled={exporting}
              onClick={onExport}
            >
              <FileDownloadOutlinedIcon fontSize="small" />
              {exporting ? "EXPORTING…" : exportLabel}
            </button>
          )}

          {canClear && (
            <button
              type="button"
              className="ds-btn ds-btn-secondary ds-btn-sm ds-filter-clear"
              onClick={onClear}
            >
              {clearLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ListingFilters;
